/** @format */

import React, { useState, useEffect } from "react";
import ProviderLayout from "views/providers/Provider";
import { useGetFellowsAttendanceQuery } from "store/services/providerAPI";
import { FadeLoader } from "react-spinners";
// import { ReactComponent as TimeIcon } from "images/svg/time.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ProgramOptions } from "utils/strings";
import AttendanceHeader from "./components/AttendanceHeader";
import AttendanceTable from "./components/AttendanceTable";

const ProviderrAttendance = () => {
  const [selectedCohort, setCohorts] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const defaultProgram = ProgramOptions.find(
    (option) => option.value === "3mtt"
  );

  const [selectedProgram, setProgram] = useState(defaultProgram);
  const [skip, setSkip] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [filter, setFilter] = useState(
    location?.search?.length > 0
      ? location?.search?.slice(1)
      : `page=1&page_size=100`
  );
  const [selected, setSelected] = useState(false);
  const [search, setSearch] = useState("");
  const [searched, setSearched] = useState(false);

  const [modalFilter, setModalFilter] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [filtered, setFiltered] = useState(false);

  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  const {
    data,
    isLoading: loadingFellows,
    isFetching: fetchingFellows,
    refetch,
  } = useGetFellowsAttendanceQuery(filter, {
    skip: skip,
  });

  useEffect(() => {
    if (selected && filter && filter.length > 0) {
      const fullPath = `${location?.pathname}?${filter}`;
      setSkip(false);
      navigate(fullPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, selected]);

  return (
    <ProviderLayout>
      {/* <p> modat:: {JSON.stringify(modalFilter)}</p> */}

      <div className="row">
        <AttendanceHeader
          setSchedule={setSchedule}
          setFilter={setFilter}
          setSelected={setSelected}
          isLoading={loadingFellows || fetchingFellows}
          handleInputChange={handleInputChange}
          setSearched={setSearched}
          setSearch={setSearch}
          setProgram={setProgram}
          setCohorts={setCohorts}
          refetchFellows={refetch}
          selectedCohort={selectedCohort}
          search={search}
          searched={searched}
          schedule={schedule}
          selectedProgram={selectedProgram}
          filterData={{
            showFilter: showFilter,
            filtering: fetchingFellows || loadingFellows,
          }}
          setShowFilter={setShowFilter}
          setModalFilter={setModalFilter}
          setFiltered={setFiltered}
        />

        <div className="w-100 d-flex align-items-center justify-content-end">
          {filtered && (
            <button
              onClick={() => {
                setSearch();
                setFilter(
                  `page=1&attendance_schedule=${schedule?.id}&program=${
                    selectedProgram?.value ?? "3mtt"
                  }&page_size=${data?.data?.metadata?.page_size}`
                );
                setModalFilter(null);
                setFiltered(false);
              }}
              className="btn text-danger"
            >
              Reset Filter
            </button>
          )}
        </div>

        {loadingFellows || fetchingFellows ? (
          <div className="d-flex justify-content-center align-items-center height-15 bg-white ">
            <FadeLoader color="#36d7b7" />
          </div>
        ) : (
          <>
            <AttendanceTable
              fellows={data?.data?.results ?? []}
              metadata={data?.data?.metadata ?? null}
              setFilter={setFilter}
              setSkip={setSkip}
              filtering={fetchingFellows || loadingFellows}
              filter={filter}
              cohort={selectedCohort}
              schedule={schedule}
              program={selectedProgram?.value ?? "3mtt"}
              refetch={refetch}
              setProgram={setProgram}
              setCohorts={setCohorts}
              setSchedule={setSchedule}
              filterData={{
                showFilter: showFilter,
                modalFilter: modalFilter,
                filtering: fetchingFellows || loadingFellows,
              }}
              setShowFilter={setShowFilter}
              setModalFilter={setModalFilter}
              setFiltered={setFiltered}
            />
          </>
        )}
      </div>
    </ProviderLayout>
  );
};
export default ProviderrAttendance;
